import * as types from '../actions/actionTypes'


const usersReducer = (state = {
    allUsers: [],
    allUsersForComposeNotification: [],
    allUsersForCreatedEvent: [],
    allRealtors: [],
    allSales: [],
    allManagers: [],
    allButAdmin: []
}, action) => {

    switch(action.type) {
      case types.GET_ALL_USERS_SUCCESS: 
      
      let tempUsers = []
      let tempRealtors = []
      let tempAllButAdmin = []
      let tempManagers = []
      let tempSales =[]
      let tempUsersForComposeNotification = []
      let tempUsersForCreatedEvent = []
      for (var usersKey in action.payload) {
        tempUsers.push(action.payload[usersKey]);
        action.payload[usersKey].role == 4 && tempRealtors.push(action.payload[usersKey])
        action.payload[usersKey].role != 1 && tempAllButAdmin.push(action.payload[usersKey])
        action.payload[usersKey].role == 3 && tempSales.push(action.payload[usersKey])
        action.payload[usersKey].role == 2 && tempManagers.push(action.payload[usersKey])
        action.payload[usersKey].isSelected = false
        tempUsersForComposeNotification.push(action.payload[usersKey])
        tempUsersForCreatedEvent.push(action.payload[usersKey])
       }

      state = {
        ...state,
        allUsers: tempUsers,
        allRealtors: tempRealtors,
        allButAdmin: tempAllButAdmin,
        allSales: tempSales,
        allManagers: tempManagers,
        allUsersForComposeNotification: tempUsersForComposeNotification,
        allUsersForCreatedEvent: tempUsersForCreatedEvent
      };
      break;
      case types.GET_ALL_MANAGERS_SUCCESS: 
      
      state = {
        ...state,
        allManagers: action.payload
      };
      break;
      case types.GET_ALL_SALES_SUCCESS: 
      
      state = {
        ...state,
        allSales: action.payload
      };
      break;
      case types.EDIT_USER_SUCCESS:
        const allUsersForEdit = state.allUsers

        let tempUsersForEdit = []
        let tempRealtorsForEdit = []
        let tempSalesForEdit = []
        let tempManagersForEdit = []
        let tempAllButAdminForEdit = []
        for (var usersKey in allUsersForEdit) {
          let tempUser = allUsersForEdit[usersKey]
          if (tempUser.uid === action.payload.uid) {
            tempUser = action.payload
          }

          tempUsersForEdit.push(tempUser);
          tempUser.role == 4 && tempRealtorsForEdit.push(tempUser)
          tempUser.role != 1 && tempAllButAdminForEdit.push(tempUser)
          tempUser.role == 3 && tempSalesForEdit.push(tempUser)
          tempUser.role == 2 && tempManagersForEdit.push(tempUser)
        }

        state = {
          ...state,
          allUsers: tempUsersForEdit,
          allRealtors: tempRealtorsForEdit,
          allManagers: tempManagersForEdit,
          allSales: tempSalesForEdit,
          allButAdmin: tempAllButAdminForEdit
        };
      break;
      case types.DELETE_USER_SUCCESS:
        const allUsersForDelete = state.allUsers.filter(userObject => userObject.uid != action.payload.uid);

        let tempUsersForDelete = []
        let tempRealtorsForDelete = []
        let tempSalesForDelete = []
        let tempManagersForDelete = []
        let tempAllButAdminForDelete = []
        for (var usersKey in allUsersForDelete) {
          let tempUser = allUsersForDelete[usersKey]

          tempUsersForDelete.push(tempUser);
          tempUser.role == 4 && tempRealtorsForDelete.push(tempUser)
          tempUser.role != 1 && tempAllButAdminForDelete.push(tempUser)
          tempUser.role == 3 && tempSalesForDelete.push(tempUser)
          tempUser.role == 2 && tempManagersForDelete.push(tempUser)
        }

        state = {
          ...state,
          allUsers: tempUsersForDelete,
          allRealtors: tempRealtorsForDelete,
          allManagers: tempManagersForDelete,
          allSales: tempSalesForDelete,
          allButAdmin: tempAllButAdminForDelete
        };
      break;
      case types.SET_CURRENT_COMPANY: 
        //if logging in with a different company wipe all of the store 
      state = {
        ...state,
        allUsers: action.payloadTwo ? state.allUsers : [],
        allRealtors: action.payloadTwo ? state.allRealtors : [],
        allSales: action.payloadTwo ? state.allSales : [],
        allManagers: action.payloadTwo ? state.allManagers : [],
        allButAdmin: action.payloadTwo ? state.allButAdmin : []
      };
      break;
      case types.SHOULD_SET_USERS_TO_SELECTED:

      let tempUnselectedUsers = []
      for (var usersKey in state.allUsers) {
        let tempUser = state.allUsers[usersKey]
        tempUser.isSelected = action.payload
        tempUnselectedUsers.push(tempUser)
      }

        state = {
          ...state,
          allUsersForComposeNotification: tempUnselectedUsers,
        };

      break;
      case types.SET_ALL_USERS_FOR_SELECTION:
        state = {
          ...state,
          allUsersForComposeNotification: action.payload,
        };
      break;
      case types.SHOULD_SET_USERS_TO_SELECTED_FOR_EVENT:

      let tempEventUnselectedUsers = []
      for (var usersKey in state.allUsers) {
        let tempUser = state.allUsers[usersKey]
        tempUser.isSelected = action.payload
        tempEventUnselectedUsers.push(tempUser)
      }

        state = {
          ...state,
          allUsersForCreatedEvent: tempEventUnselectedUsers,
        };

      break;
      case types.SET_ALL_USERS_FOR_EVENT_SELECTION:
        state = {
          ...state,
          allUsersForCreatedEvent: action.payload,
        };
      break;
      default:
      break;    
    }

    return state;
};


export default usersReducer;


// WEBPACK FOOTER //
// ./src/reducers/usersReducer.js